export default "__VITE_ASSET__C6ZXq2TV__"